import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link, Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AssistantLoginLinkProps {
  restaurantId: string;
}

export function AssistantLoginLink({ restaurantId }: AssistantLoginLinkProps) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const baseUrl = window.location.origin;
  const loginUrl = `${baseUrl}/assistant-login?restaurant=${restaurantId}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(loginUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="flex items-center gap-2 p-3 bg-blue-50 dark:bg-blue-950 rounded-md border border-blue-200 dark:border-blue-800">
      <Link className="w-4 h-4 text-blue-600 flex-shrink-0" />
      <code className="flex-1 text-sm text-blue-700 dark:text-blue-300 overflow-x-auto">
        {loginUrl}
      </code>
      <Button
        variant="outline"
        size="icon"
        onClick={handleCopy}
        title={copied ? t('common.copied') || 'Copied!' : t('common.copy') || 'Copy to clipboard'}
        className="flex-shrink-0"
      >
        {copied ? (
          <Check className="w-4 h-4 text-green-600" />
        ) : (
          <Copy className="w-4 h-4" />
        )}
      </Button>
    </div>
  );
}
